import { Validator } from 'projects/core/src/lib/helpers/validator';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { TimezoneService } from '../services/timezone.service';

@Pipe({
  name: 'timer',
})
export class TimerPipe implements PipeTransform {

  constructor() { }

  transform(value: number): string {
    return (!isNaN(value)) ? ('0' + Math.floor(value / 60)).slice(-2) + ':' + ('0' + (value % 60)).slice(-2) : '';
  }

}
